// extracted by mini-css-extract-plugin
module.exports = {"ChartCard":"ChartCard_ChartCard__3z6vy"};